/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForCostCenterGcp extends models.ServiceAccountNativeDetailsBaseForCostCenterCloud {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForCostCenterGcp");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForCostCenterGcp.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForCostCenterGcp>): ServiceAccountNativeDetailsForCostCenterGcp {
        let obj = Object.assign(new ServiceAccountNativeDetailsForCostCenterGcp(), model);
        ServiceAccountNativeDetailsForCostCenterGcp.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForCostCenterGcp>): ServiceAccountNativeDetailsForCostCenterGcp {
        if (!model) return null;
        return ServiceAccountNativeDetailsForCostCenterGcp.newInstance(<ServiceAccountNativeDetailsForCostCenterGcp> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForCostCenterGcp) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForCostCenterGcp.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForCostCenterGcp): boolean {
        if (models.ServiceAccountNativeDetailsBaseForCostCenterCloud.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForCostCenterGcp.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Tenant Id
     */
    tenant_id: string;

}
